import classNames from 'classnames'
import { Button } from '~/components/Button'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { useCustomer, useFormatPrice } from '~/hooks'
import styles from './CartDrawerFooter.module.css'
import { CartDrawerFooterProps } from './CartDrawerFooter.types'

const BNPLs = [
  { icon: '/images/icons/bnpl_zip.svg', label: 'zip', name: 'ZipPayLater' },
  { icon: '/images/icons/bnpl_humm.svg', label: 'humm', name: 'HummPayLater' },
  {
    icon: '/images/icons/bnpl_afterpay.svg',
    label: 'afterPay',
    name: 'AfterPayLater',
  },
  {
    icon: '/images/icons/bnpl_latitude.svg',
    label: 'latitude',
    name: 'LatitudePayLater',
  },
  {
    icon: '/images/icons/bnpl_gem.svg',
    label: 'gem',
    name: 'GemPayLater',
  },
]

export const CartDrawerFooter = ({
  hasItemsInCart,
  subtotal,
  points,
  onClose,
  payLaterProviders,
  promotionSavings,
}: CartDrawerFooterProps) => {
  const { formatPrice } = useFormatPrice()
  const { customer } = useCustomer()

  return (
    <>
      {hasItemsInCart && (
        <div className='mb-2.5 lg:mb-4'>
          {promotionSavings && (
            <div className='flex items-center justify-between mb-4'>
              <Typography
                tag={TypographyTag.p}
                variant={TypographyVariant.BodyRegularBold}
                className='text-state-alert-info'>
                Promotion savings
              </Typography>
              <Typography
                tag={TypographyTag.p}
                variant={TypographyVariant.BodyRegularBold}>
                {formatPrice(promotionSavings)}
              </Typography>
            </div>
          )}
          <div className='flex items-center justify-between'>
            <Typography
              tag={TypographyTag.p}
              variant={TypographyVariant.BodyLargeBold}
              className={classNames('text-secondary-muted', styles.title)}>
              Sub-total:
            </Typography>
            <Typography
              tag={TypographyTag.p}
              variant={TypographyVariant.BodyLargeBold}
              className={classNames('text-secondary-muted', styles.title)}>
              {subtotal && formatPrice(subtotal)}
            </Typography>
          </div>
          {customer?.isSignedIn && !!points && (
            <div className='mt-1 text-right'>
              <Typography
                tag={TypographyTag.p}
                variant={TypographyVariant.BodyRegular}>
                You will earn{' '}
                <span className='font-extrabold inline-block'>
                  {points} Jaycar Points
                </span>
              </Typography>
            </div>
          )}
        </div>
      )}
      <div className='grid grid-cols-2 gap-x-4'>
        <Button
          status='secondary'
          fluid
          onClick={() => {
            onClose?.()
          }}>
          Continue Shopping
        </Button>
        <Button
          data-id='checkoutButton'
          disabled={!hasItemsInCart}
          fluid
          href='/checkout'>
          Checkout
        </Button>
      </div>
      <div className='mt-2 lg:mt-4 text-center'>
        <Typography
          tag={TypographyTag.p}
          variant={TypographyVariant.BodySmallExtraLineHeight}
          className='text-secondary-muted'>
          Buy now, pay later with
        </Typography>
        <div className='flex divide-x items-center mt-1'>
          {!!payLaterProviders?.length &&
            payLaterProviders.map((item, index) => {
              const bnplIcon = BNPLs.find(({ name }) => {
                return name === item.name
              })

              return (
                <div
                  key={index}
                  className='flex-1 text-center leading-none border-primary-border'>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={bnplIcon?.icon}
                    alt={bnplIcon?.label}
                    className='inline h-4'
                  />
                </div>
              )
            })}
        </div>
      </div>
    </>
  )
}
